import { AfterViewInit, Component, Input } from "@angular/core";

@Component({
  selector: "kl-tabs-hover",
  templateUrl: "./tabs-hover.component.html",
  styleUrls: ["./tabs-hover.component.scss"],
})
export class TabsHoverComponent implements AfterViewInit {
  @Input() tabTitle: string;
  @Input() tabMode: string;
  @Input() positions: {
    left: string;
    top: string;
  };

  ngAfterViewInit(): void {
    const element = document.getElementById("hover-container");
    element.style.left =
      parseInt(this.positions.left) - element.offsetWidth * 0.5 + "px";
    element.style.top = this.positions.top;
  }
}
